import { LambdaDef } from "./lambda";

export const buildScheduleHandlerDef = <
  D extends string,
  E extends string,
  L extends LambdaDef<D, E>,
>({
  handler,
}: {
  envKeys: readonly E[];
  handler: L;
}): LambdaDef<D, E> & { pkg: L["pkg"] } => ({
  ...handler,
});
